import { PageLang } from '../pageLang'

const CONTENT: Record<PageLang, { eyebrow: string; headline: string; followers: string }> = {
  EN: { eyebrow: 'Follow us', headline: 'HAUP on social media', followers: 'followers' },
  TH: { eyebrow: 'ติดตามเรา', headline: 'HAUP บนโซเชียลมีเดีย', followers: 'ผู้ติดตาม' },
}

const SOCIAL_ICONS = {
  line: 'https://ts-upload.sgp1.digitaloceanspaces.com/cms/5ZUpHjQdM2R8pvqmnTvML7hgmKywze2gBfAMsHLM8qfGHhFsFoHzgTu2GpCiGQDCdDQEQczBfpvX6xBG9mc1CuDe.png',
  facebook:
    'https://ts-upload.sgp1.digitaloceanspaces.com/cms/3ojYSQ97EBqNNFgwFE7rkLrBUsmDCvKgnimsJVhiZAMgFPzuCtEAdFrDXggvKLidHgMKUMpq2xedA3zHf47ysrqm.png',
  instagram:
    'https://ts-upload.sgp1.digitaloceanspaces.com/cms/3J2mkwUhuNwmiMGbCqX7WG6Pnf3Ebto1TJMGBnjYwAy7BvPTB43HPVtk6QFhSAGJPDXUqpMcSYwPAzgE1RtfET3X.png',
  tiktok:
    'https://ts-upload.sgp1.digitaloceanspaces.com/cms/2Q2dZNqEHpZVcf23UAw3w7HL3fZXwNiHxMmBwizyyURmw1a7eJ9bwrmhCVDvcZGNgUCNPuTh3tmbSjHLDU3WSFH7.png',
}

const SOCIAL_LINKS = [
  {
    icon: SOCIAL_ICONS.line,
    label: 'LINE',
    href: 'https://page.line.me/630rspua',
    followers: '59K',
    bgColor: '#F3FBF3',
    textColor: '#06C755',
  },
  {
    icon: SOCIAL_ICONS.facebook,
    label: 'Facebook',
    href: 'https://www.facebook.com/HAUPCAR/',
    followers: '128K',
    bgColor: '#EAF2FE',
    textColor: '#1877F2',
    iconSize: 26,
  },
  {
    icon: SOCIAL_ICONS.instagram,
    label: 'Instagram',
    href: 'https://www.instagram.com/haupcar/',
    followers: '3.3K',
    bgColor: '#FDF1F7',
    textColor: '#C13584',
  },
  {
    icon: SOCIAL_ICONS.tiktok,
    label: 'TikTok',
    href: 'https://www.tiktok.com/@haupcar',
    followers: '6.6K',
    bgColor: '#F4F4F5',
    textColor: '#111111',
  },
]

export interface SocialSectionProps {
  lang: PageLang
}

export const SocialSection = ({ lang }: SocialSectionProps) => {
  const t = CONTENT[lang]
  return (
    <div style={{ padding: '32px 16px 8px' }}>
      <div
        style={{
          display: 'inline-block',
          backgroundColor: '#EAF1FF',
          color: '#0048B3',
          fontSize: '12px',
          fontWeight: 600,
          padding: '4px 12px',
          borderRadius: '12px',
          marginBottom: '12px',
        }}
      >
        {t.eyebrow}
      </div>
      <h2 style={{ fontSize: '17px', fontWeight: 600, color: '#212427', margin: '0 0 14px' }}>
        {t.headline}
      </h2>
      <div style={{ display: 'flex', gap: '10px' }}>
        {SOCIAL_LINKS.map((social) => (
          <a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noreferrer"
            style={{
              flex: 1,
              textAlign: 'center',
              backgroundColor: social.bgColor,
              borderRadius: '12px',
              padding: '12px 4px',
              textDecoration: 'none',
            }}
          >
            <div
              style={{
                width: '32px',
                height: '32px',
                margin: '0 auto 6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={social.icon}
                alt={social.label}
                style={{
                  width: `${social.iconSize ?? 32}px`,
                  height: `${social.iconSize ?? 32}px`,
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            </div>
            <div style={{ fontSize: '14px', fontWeight: 700, color: social.textColor }}>
              {social.followers}
            </div>
            <div style={{ fontSize: '10.5px', color: '#8C97A7' }}>{t.followers}</div>
          </a>
        ))}
      </div>
    </div>
  )
}

export default SocialSection
